$(function() {
  $('.js-searchBtn').on('click', function(){
    if (!$('.js-searchBtn').hasClass('is-active')) {
      $('.js-searchBtn').addClass('is-active')
      $('.js-searchBtn')
        .closest('.l-header-top')
        .addClass('is-active')
      setTimeout(function(){
        $('.searchInput').focus()
      }, 400)
    } else {
      $('.js-searchBtn').removeClass('is-active')
      $('.js-searchBtn')
        .closest('.l-header-top')
        .removeClass('is-active')
    }
  })
  $(document).on('click touchstart', function(e){
    if (!$(e.target).closest('.js-searchBox,.js-searchBtn').length) {
      $('.js-searchBtn').removeClass('is-active')
      $('.js-searchBtn')
        .closest('.l-header-top')
        .removeClass('is-active')
    }
  })
})
